<template>
  <v-main>
    <v-container fluid>

      <!-- Page Header -->
      <v-row class="mb-4">
        <v-col cols="12">
          <v-card elevation="4" rounded="xl">
            <v-card-text class="py-3 px-5">
              <div class="d-flex align-center">
                <v-btn fab x-small color="primary" class="mr-3" @click="$router.back()">
                  <v-icon dark>mdi-arrow-left</v-icon>
                </v-btn>
                <div>
                  <h2 class="font-weight-bold mb-0" style="color: #1a1a2e;">Gift Catalogs Point Wise</h2>
                  <span class="text-caption grey--text">Browse available gift items and required points</span>
                </div>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="trackProgresses.length > 0"
                  color="primary"
                  rounded
                  :to="`/gift-catalogs/${$route.params.positionId}/edit`"
                >
                  <v-icon left>mdi-pencil</v-icon>
                  Edit Catalog
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Loading -->
      <v-row v-if="isLoading">
        <v-col cols="12">
          <v-progress-linear indeterminate color="primary" rounded></v-progress-linear>
        </v-col>
      </v-row>

      <!-- Gift Cards Grid -->
      <v-row v-else-if="trackProgresses && trackProgresses.length > 0">
        <v-col
          v-for="(level, index) in trackProgresses"
          :key="index"
          cols="12" sm="6" md="4" lg="3"
        >
          <v-card
            elevation="4"
            rounded="xl"
            class="overflow-hidden gift-card"
            height="100%"
            style="display: flex; flex-direction: column;"
          >
            <!-- Order badge ribbon -->
            <div
              class="d-flex align-center justify-space-between px-4 py-2"
              style="background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);"
            >
              <div class="d-flex align-center">
                <v-avatar size="26" color="primary" class="mr-2">
                  <span class="white--text font-weight-bold" style="font-size: 11px;">{{ index + 1 }}</span>
                </v-avatar>
                <span class="white--text text-caption font-weight-medium">Level {{ index + 1 }}</span>
              </div>
              <v-chip x-small color="primary" dark>
                <v-icon left x-small>mdi-star</v-icon>
                {{ level.points }} pts
              </v-chip>
            </div>

            <!-- Product Image -->
            <div style="background: #f8f9fa; position: relative;">
              <v-img
                v-if="level.image_path"
                :src="mediaUrl + level.image_path"
                height="200"
                contain
                class="pa-3"
              >
                <template v-slot:placeholder>
                  <div class="d-flex align-center justify-center" style="height:200px;">
                    <v-progress-circular indeterminate color="grey lighten-3"></v-progress-circular>
                  </div>
                </template>
              </v-img>
              <div
                v-else
                class="d-flex align-center justify-center"
                style="height: 200px;"
              >
                <v-icon size="64" color="grey lighten-3">mdi-gift</v-icon>
              </div>
            </div>

            <!-- Card Content -->
            <v-card-text class="flex-grow-1 pa-4">
              <h3 class="text-subtitle-1 font-weight-bold mb-1" style="color: #1a1a2e; line-height: 1.3;">
                {{ level.name }}
              </h3>
              <div v-if="level.amount" class="text-caption grey--text mb-2">
                <v-icon x-small color="grey">mdi-currency-inr</v-icon>
                MRP {{ level.amount }}
              </div>
              <div v-if="level.hsn_code" class="text-caption grey--text">
                HSN: {{ level.hsn_code }}
              </div>
            </v-card-text>

            <!-- Points Footer -->
            <v-divider></v-divider>
            <div class="d-flex align-center justify-center py-3" style="background: #fafafa;">
              <v-icon color="primary" class="mr-1">mdi-star-circle</v-icon>
              <span class="font-weight-bold text-h6" style="color: #e60040;">{{ level.points }}</span>
              <span class="ml-1 grey--text text-caption font-weight-medium">Points Required</span>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Empty State -->
      <v-row v-else>
        <v-col cols="12">
          <v-card elevation="2" rounded="xl">
            <v-card-text class="text-center py-16">
              <v-icon size="80" color="grey lighten-3">mdi-gift-off-outline</v-icon>
              <h3 class="text-h6 grey--text font-weight-medium mt-4 mb-2">No Gift Catalogs Found</h3>
              <p class="text-body-2 grey--text mb-4">No items have been added to this catalog yet.</p>
              <v-btn color="primary" rounded to="/gift-catalogs/create">
                <v-icon left>mdi-plus</v-icon>
                Add Catalog
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "GiftCatalogIdPage2",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        position_id: "",
      },
      trackProgresses: [],
      isLoading: false,
    };
  },
  watch: {
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword || "";
      this.filter.position_id = this.$route.params.positionId
        ? this.decryptIt(this.$route.params.positionId)
        : "";
      this.filter.is_active = this.filter.is_active || "";

      let query =
        "position_id=" + this.filter.position_id +
        "&is_active=" + this.filter.is_active +
        "&search_keyword=" + this.filter.search_keyword;

      await axios
        .get(`gift_catalogs?${query}`)
        .then((response) => {
          this.trackProgresses = response.data.data;
          this.count = response.data.count;
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.gift-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.gift-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15) !important;
}
</style>
